/*
 * @Description:
 * @Date: 2020-09-26 17:18:51
 * @LastEditors: jml
 */
import request from "@/utils/request";
const baseUrl = "/rest/channel/pc";

export const puzzle = {
  // 获得混乱的九宫格图片
  sudokuImage(data) {
    return request.post(`${baseUrl}/puzzle/sudokuImage`, data);
  },
  // 拼图验证
  judgeComplete(data) {
    return request.post(`${baseUrl}/puzzle/judgeComplete`, data);
  },
  // 挑战信息
  challengeData(data) {
    return request.post(`${baseUrl}/puzzle/challengeData`, data);
  },
  // 排行榜
  rankList(data) {
    return request.post(`${baseUrl}/puzzle/rankList`, data);
  },
  // 活动详情
  activityData(data) {
    return request.post(`${baseUrl}/puzzle/activityData`, data);
  },
  // 新增修改地址
  addUpdateAddress(data) {
    return request.post(`${baseUrl}/puzzle/addUpdateAddress`, data);
  },
  // 地址详情
  addressData(data) {
    return request.post(`${baseUrl}/puzzle/addressData`, data);
  },
  // 活动列表
  activityList(data) {
    return request.post(`${baseUrl}/puzzle/activityList`, data);
  },
  // 中奖记录
  prizeList(data) {
    return request.post(`${baseUrl}/puzzle/prizeList`, data);
  },
};
